import { ToggleButton } from '@material-ui/lab';
import { Box, Checkbox, FormControlLabel, makeStyles } from '@material-ui/core';
import Typography from '../../../components/overrides/Typography';
import clsx from 'clsx';

const useStyles = makeStyles((theme) => ({
  rowContainer: {
    display: 'flex',
    flexWrap: 'wrap',
    flexDirection: 'row',
    gap: theme.spacing(2.5),
  },

  toggleButton: {
    padding: theme.spacing(1, 1.5),
    borderRadius: '8px',
    borderColor: theme.palette.spoon.neutral.emphasisMedium,
    textAlign: 'left',
    '&.Mui-selected': {
      backgroundColor: theme.palette.spoon.blue[40],
      borderColor: theme.palette.spoon.blue[40],
      '& .MuiTypography-colorTextPrimary': {
        color: theme.palette.spoon.white[100],
      },
      '&:hover': {
        backgroundColor: theme.palette.spoon.blue[50],
        borderColor: theme.palette.spoon.blue[50],
      },
      '& img': {
        filter: 'brightness(0) invert(1)',
      },
      '&.Mui-focusVisible': {
        outline: 'none',
        boxShadow: `0 0 0 2px ${theme.palette.spoon.black[100]}`,
      },
    },
    '&.Mui-focusVisible': {
      outline: 'none',
      boxShadow: `0 0 0 2px ${theme.palette.interactionBlue.main}`,
    },
    '& .MuiToggleButton-label': {
      height: '100%',
    },
  },

  toggleButtonContent: {
    display: 'flex',
    flexDirection: 'column',
    gap: theme.spacing(1),
  },

  toggleButtonContentWithIcon: {
    '& img': {
      width: '24px',
      height: '24px',
      filter: 'brightness(0)',
    },
    gap: theme.spacing(1),
    width: theme.spacing(20),
    height: '100%',
    textTransform: 'capitalize',
    '& p': {
      fontSize: '16px',
      lineHeight: '24px',
    },
    padding: theme.spacing(1, 0.5),
    boxSizing: 'border-box',
  },

  spacer: {
    flexGrow: 1,
  },

  columnContainer: {
    display: 'flex',
    flexDirection: 'column',
    gap: theme.spacing(1),
  },

  checkbox: {
    '&.MuiCheckbox-root': {
      color: theme.palette.secondary[65],
      marginLeft: theme.spacing(1.5),
    },
    '&.Mui-checked': {
      color: theme.palette.spoon.blue[40],
    },
  },

  checkboxLabel: {
    paddingLeft: theme.spacing(1),
  },
}));

export const ButtonList = ({ list, activeList, onClick, id }) => {
  const classes = useStyles();
  return (
    <Box className={classes.rowContainer}>
      {list.map((item, index) => (
        <ToggleButton
          key={`filterSelect-${index}`}
          focusRipple={false}
          selected={activeList?.some((listItem) => listItem.id === item.id)}
          onChange={() => onClick(item, id)}
          className={classes.toggleButton}>
          <Box
            className={clsx(classes.toggleButtonContent, {
              [classes.toggleButtonContentWithIcon]: item.icon,
            })}>
            {item.icon && (
              <>
                <img src={item.icon} alt="" />
                <Box className={classes.spacer} />
              </>
            )}
            <Typography variant="small2Normal">{item.name}</Typography>
          </Box>
        </ToggleButton>
      ))}
    </Box>
  );
};

export const CheckboxList = ({ list, activeList, onClick, id }) => {
  const classes = useStyles();
  return (
    <Box className={classes.columnContainer}>
      {list.map((item, index) => (
        <FormControlLabel
          key={`filterSelect-${index}`}
          control={
            <Checkbox
              checked={activeList?.some((listItem) => listItem.id === item.id)}
              onChange={() => onClick(item, id)}
              name={item.name}
              className={classes.checkbox}
            />
          }
          label={
            <Typography
              variant="medium1Normal"
              className={classes.checkboxLabel}>
              {item.name}
            </Typography>
          }
        />
      ))}
    </Box>
  );
};
